import React from 'react';

import styled from 'styled-components';

import HeaderUserActions from './HeaderUserActions';

const Container = styled.div`
  display: flex;
  justify-content: end;
  gap: 30px;
  padding-right: 10px;
`;

const HeaderUser = () => (
  <Container>
    <HeaderUserActions />
  </Container>
);

export default HeaderUser;
